import RoleCard from "./RoleCard";
import ProductDropdown from "components/forms/ProductDropdown";
import { useEffect, useState } from "react";
import Breadcrumbs from "components/base/breadcrumbs";
import BreadcrumbDirective from "components/base/breadcrumbs/BreadcrumbDirective";
import CardHeader from "components/cards/CardHeader";
import Button from "components/base/button/Button";
import { useTranslation } from "react-i18next";
import { useUserManagementContext } from "hooks‬/dashoard/UserManagementContext";
import { ValidateConstant } from "constant/dashboardConstant";
import CreateNewRole from "./CreateNewRole";
import { useNavigate, useSearchParams } from "react-router-dom";
import apiInterceptor from "services/apiInterceptor";
import { subscriptionApiEndpoint } from "constant/apiConstants";
import { useFeatureAccess } from "hooks‬/custome-hooks/useFeatureAccess";
import { featureObject } from "helpers/privileges/utils";
import ButtonTooltip from "components/base/ButtonTooltip";
import { useAuth } from "hooks‬/Auth";
import PageLoader from "components/base/PageLoader";
const Index = () => {
  const { t } = useTranslation();
  const { isReadOnlyFeature, companySubscriptionDetails, featureLimitStatus } =
    useAuth();
  const { canCreate } = useFeatureAccess(featureObject.USR_ROLE);
  const { product, fetchUserRoleHandler } = useUserManagementContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const productGuid = searchParams.get("product");
  const [selectedProduct, setSelectedProduct] = useState<string>("");
  const pageRenderSate = ValidateConstant.INDEX;
  const [roles, setRoles] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [showCreateRolePopup, setShowCreateRolePopup] = useState(false);
  const [selectedRole, setSelectedRole] = useState<any>({
    value: "",
    label: "",
  });
  const [isCloneRole, setIsCloneRole] = useState(false);
  const [isUpdateRole, setIsUpdateRole] = useState(false);

  const closeShowCreateRolePopupHandler = () => {
    setShowCreateRolePopup(false);
  };

  useEffect(() => {
    fetchUserRoleHandler();
    // eslint-disable-next-line
  }, []);

  const fetchRoleHnalder = async (productGuid: string) => {
    setIsLoading(true);
    await apiInterceptor
      .get(
        `${subscriptionApiEndpoint.ENDPOINT_ALL_PRODUCTS}/${productGuid}/roles`
      )
      .then((response) => {
        setRoles(response.data.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (productGuid) {
      fetchRoleHnalder(productGuid);
    }
  }, [productGuid]);

  useEffect(() => {
    if (product.length > 0) {
      const hasValidProductGuid = product.some(
        (p: any) => p.value === productGuid
      );
      if (hasValidProductGuid) {
        setSelectedProduct(productGuid as string);
      } else {
        setSelectedProduct(product[0].value);
        const newParams = new URLSearchParams(searchParams.toString());
        newParams.set("product", product[0].value);
        navigate({ search: newParams.toString() });
      }
    }
    // eslint-disable-next-line
  }, [product]);

  const handleProductChange = (guid: string) => {
    setSelectedProduct(guid);
    const newParams = new URLSearchParams(searchParams.toString());
    newParams.set("product", guid);
    navigate({ search: newParams.toString() });
  };
  if (isLoading) {
    return <PageLoader />;
  }
  return (
    <div className="container  container-xxl ">
      <Breadcrumbs>
        <BreadcrumbDirective to="/dashboard" label="Dashboard" />
        <BreadcrumbDirective label="Roles" />
      </Breadcrumbs>{" "}
      <div className="card p-10  my-5">
        {pageRenderSate === ValidateConstant.INDEX && (
          <>
            <CardHeader>
              <h3 className="my-4">{t("Roles")}</h3>
              {canCreate && (
                <div className="my-4">
                  <ButtonTooltip
                    title={
                      companySubscriptionDetails?.isExpired
                        ? "You do not have active subscription to access this feature."
                        : "Role limit exceeded. Upgrade your plan to add more roles."
                    }
                    isShow={isReadOnlyFeature(
                      featureLimitStatus?.IS_CUSTOM_ROLE_CREATION_EXCEED
                    )}
                  >
                    <Button
                      classes="btn-sm rounded btn-primary"
                      onClick={() => {
                        setIsCloneRole(false);
                        setIsUpdateRole(false);
                        setShowCreateRolePopup(true);
                        setSelectedRole({
                          value: "",
                          label: "",
                        });
                      }}
                      disabled={isReadOnlyFeature(
                        featureLimitStatus?.IS_CUSTOM_ROLE_CREATION_EXCEED
                      )}
                    >
                      <span className=" text-capitalize"> {t("ADD.ROLE")}</span>
                    </Button>
                  </ButtonTooltip>
                </div>
              )}
            </CardHeader>

            <div className=" d-flex align-items-center mb-4 ">
              <label className="me-5 text-primary-white fs-4 ">
                {t("PRODUCT.COLON")}
              </label>
              <div className="w-250px">
                <ProductDropdown
                  name="selectedProduct"
                  value={selectedProduct}
                  onChange={(event) => {
                    handleProductChange(event.target.value);
                  }}
                  selectionOptions={product}
                />
              </div>{" "}
            </div>
            <div className="row row-cols-1  g-5 g-xl-9">
              {roles.map((item: any) => {
                return (
                  <div key={item.guid} className="col-md-6 col-lg-4 col-xxl-4">
                    <RoleCard
                      role={item}
                      setIsCloneRole={setIsCloneRole}
                      setIsUpdateRole={setIsUpdateRole}
                      setSelectedRole={setSelectedRole}
                      setShowCreateRolePopup={() =>
                        setShowCreateRolePopup(true)
                      }
                      fetchAPI={() => fetchRoleHnalder(productGuid ?? "")}
                    />{" "}
                  </div>
                );
              })}
            </div>
          </>
        )}

        <CreateNewRole
          roles={roles}
          showModal={showCreateRolePopup}
          closeModal={closeShowCreateRolePopupHandler}
          fetchAPI={() => fetchRoleHnalder(productGuid ?? "")}
          selectedRole={selectedRole}
          isUpdateRole={isUpdateRole}
          isCloneRole={isCloneRole}
        />
      </div>
    </div>
  );
};

export default Index;
